const logoSrc = `${process.env.PUBLIC_URL || ""}/plaza-mark-transparent.webp`;

export function BrandMark({ className = "h-8 w-8" }) {
  return (
    <span className={`relative inline-flex items-center justify-center shrink-0 ${className}`} aria-hidden="true">
      <img
        src={logoSrc}
        alt="Plaza Kreasi"
        className="w-full h-full object-contain"
      />
    </span>
  );
}
